import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import TopWave from '../../../images/waves/home-top-wave.inline.svg';
import RightArrow from '../../../images/icons/arrow-right.inline.svg';
import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

const AboutBannerWaveContainer = styled.div`
    position: relative;
    .button-container {
        top: 14vh;
        left: 0;
        width: 100%;
        text-align: center;
        max-width: 100vw;
        z-index: 10;
        padding: 10vh 0 0;
        ${media.large`position: absolute; padding: 0;`}
        a {
            color: #fff;
            text-decoration: none;
            font-size: 1.3rem;
            display: flex;
            align-items: center;
            background: #f74d33;
            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
            border-radius: 5px;
            text-align: center;
            padding: 25px 20px;
            justify-content: space-between;
            max-width: 350px;
            margin: 0 auto;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;

            span {
                svg {
                    position: relative;
                    top: 4px;
                }
            }
        }
    }
    .wave-wrapper {
        background-color: #f2f0eb;
        position: relative;
        overflow: hidden;
        max-width: 100vw;

        .svg-container {
            background-color: #f2f0eb;
            position: relative;

            ${media.medium`margin-bottom: -20vh;top: -20vh;`}

            svg {
                width: 100%;
                height: auto;
                path {
                    fill: #fff;
                    opacity: 1;
                }
            }
        }
        .content-color-bg {
            padding: 50px 0 40vh;
            ${media.medium`padding: 0px 0 50vh;`}
            .content-container {
                text-align: center;

                h3 {
                    font-size: 3.5rem;

                    margin: 0 0 15px;
                    font-weight: 800;
                    line-height: 1;
                    color: #000;
                    font-family: neue-kabel, sans-serif;
                    ${media.large`font-size: 4rem;`}
                }

                p {
                    font-size: 1.2rem;
                    line-height: 1.6;
                    max-width: 550px;
                    margin: 0 auto;
                }

                .btn-container {
                    margin-top: 30px;
                    a {
                        color: #fff;
                        background-color: #f74d33;
                        text-decoration: none;
                        font-weight: bold;
                        font-size: 1.1rem;
                        border-radius: 5px;
                        line-height: 1;
                        display: inline-block;
                        padding: 20px 0;
                        max-width: 225px;
                        width: 100%;
                        font-weight: 800;
                        font-family: neue-kabel, sans-serif;
                    }
                }
            }
        }
    }

    .banner-container {
        position: relative;
        top: -30vh;
        margin-bottom: -30vh;
        ${media.medium`max-width: 80vw; margin-bottom: -40vh; top: -40vh;`}
        .image-container {
            margin-bottom: 10vh;
            ${media.medium`margin-bottom: 25vh;`}
            .gatsby-image-wrapper {
                min-height: 40vh;
            }
        }
        .content-container {
            width: 100%;
            ${media.medium`position: absolute;bottom: -7vh;left: 6vw;`}

            .inner-wrap {
                max-width: 450px;
                background-color: #f2f0eb;
                box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                padding: 50px 40px;

                h3 {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #000;
                    margin: 0 0 20px;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
                p {
                    font-size: 1.05rem;
                    line-height: 1.5;
                    margin: 0;
                }
            }
        }
    }
`;

const AboutBannerWave = ({
    nextButton,
    waveButton,
    title,
    caption,
    bbTitle,
    bbCaption,
    bbImage,
    color,
}) => {
    function generateBannerContent() {
        return { __html: bbCaption };
    }

    return (
        <AboutBannerWaveContainer>
            <Wrapper className="button-container">
                <Link style={{ backgroundColor: color }} to={nextButton.url}>
                    <span>{nextButton.title} </span>
                    <span>
                        <RightArrow />
                    </span>
                </Link>
            </Wrapper>
            <Wrapper className="wave-wrapper">
                <div className="svg-container">
                    <TopWave />
                </div>
                <div className="content-color-bg">
                    <Wrapper className="content-container">
                        <h3>{title}</h3>
                        <p>{caption}</p>
                        <div className="btn-container">
                            <Link to={waveButton.url}>{waveButton.title}</Link>
                        </div>
                    </Wrapper>
                </div>
            </Wrapper>
            <Wrapper className="banner-container">
                <div className="image-container">
                    <Img fluid={bbImage.localFile.childImageSharp.fluid} />
                    <div className="content-container">
                        <div className="inner-wrap">
                            <h3>{bbTitle}</h3>
                            <div
                                className="content"
                                dangerouslySetInnerHTML={generateBannerContent()}
                            ></div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </AboutBannerWaveContainer>
    );
};

export default AboutBannerWave;
